import * as React from "react";
import {
  Grid,
  Button,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Typography,
  List,
  ListItem,
} from "@mui/material";

import ImageButton from "../Components/CustomMui/ImageButton";

export default function Home() {
  const handleClick = (buttonText: string) => {
    if (buttonText === "Patreon") {
      window.location.href = "https://www.patreon.com/c/RowanVR";
    } else {
      window.location.href = "https://bsky.app/profile/rowanvr.games";
    }
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      gridTemplateRows={"repeat(3, 1fr)"}
      paddingTop={10}
    >
      <Card variant="outlined" sx={{ width: 0.5 }}>
        <Typography
          sx={{ color: "text.primary", fontSize: 25, paddingTop: 2 }}
          align="center"
        >
          Rowans VR Games
        </Typography>
        <CardContent
          sx={{
            width: 0.25,
            height: 0.25,
            minHeight: 128,
            minWidth: 128,
            margin: "auto",
          }}
        >
          <CardMedia component="img" image="/images/avatar.png" alt="Avatar" />
        </CardContent>
        <div style={{ textAlign: "center", paddingLeft: 5, paddingRight: 5 }}>
          <Typography sx={{ color: "text.primary", fontSize: 16 }}>
            This website is currently a work in progress.
          </Typography>
        </div>
        <br />
        <div style={{ textAlign: "center" }}>
          <Typography sx={{ color: "text.primary", fontSize: 16 }}>
            You will soon be able to link your Patreon/VRChat/Discord accounts
            together. This will allow for automatic rewards in my game worlds
            without the need to wait for me to manually update them.
          </Typography>
        </div>
        <br />
        <div style={{ textAlign: "center" }}>
          <Typography sx={{ color: "text.primary", fontSize: 16 }}>
            For now though, you can use the following links to get updates.
          </Typography>
        </div>

        <CardActions sx={{ justifyContent: "center" }}>
          <List
            sx={{
              margin: "auto",
            }}
          >
            <ListItem
              sx={{
                height: 128,
                margin: "auto",
              }}
            >
              <ImageButton
                imageLocation="/images/patreon_logo.png"
                minImageSize={16}
                maxImageSize={256}
                text="Patreon"
                fontSize={1}
                onClick={() => {
                  handleClick("Patreon");
                }}
              />
            </ListItem>

            <ListItem
              sx={{
                height: 128,
                margin: "auto",
              }}
            >
              <ImageButton
                imageLocation="images/bluesky_logo.png"
                minImageSize={16}
                maxImageSize={256}
                text="Bluesky"
                fontSize={1}
                onClick={() => {
                  handleClick("Bluesky");
                }}
              />
            </ListItem>
          </List>
        </CardActions>
      </Card>
    </Grid>
  );
}
